import { GenericBackendResponse } from '../genericBackendResponse';

export { default as getPensionIsinCatalog } from './getCatalog';
export { default as createPensionPlanTransfer } from './createTransfer';
export { default as getMyPensionPlanTransfers } from './getMyTransfers';
export { default as contactExpert } from './contactExpert';
export * from './interfaces/PensionPlanTransfer';

// --- Transfer Comparison types + function ---

export interface PlanReturns {
	name: string;
	manager: string;
	return1y: number | null;
	return3y: number | null;
	return5y: number | null;
	return10y: number | null;
	// 15/20 años: el backend (comparison) los expone desde el registry. Opcionales por
	// compatibilidad con respuestas anteriores a esa ampliación.
	return15y?: number | null;
	return20y?: number | null;
	estimatedCommission: number;
	isEstimatedCommission: boolean;
	/**
	 * Comisión de GESTIÓN sola (sin depósito), de la tabla correspondiente: catalog para
	 * el plan Arca, registry para el origen. Es la que mostramos (cuadra con el onboarding).
	 * `estimatedCommission`/`totalCommission` siguen siendo el total con depósito.
	 */
	managementCommission: number;
}

export interface ArcaPlanReturns extends PlanReturns {
	id: string;
	totalCommission: number;
}

export interface TransferComparisonData {
	originPlan: PlanReturns;
	arcaPlan: ArcaPlanReturns;
	returnDiff5y: number | null;
	returnDiff10y: number | null;
}

export const getTransferComparison = async (
	token: string,
	transferId: string
): Promise<GenericBackendResponse<TransferComparisonData>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/my-transfers/${transferId}/comparison`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(`Transfer comparison request failed: ${response.status}`);
	}

	return response.json();
};

export const lockTransferPlan = async (
	token: string,
	transferId: string
): Promise<GenericBackendResponse<{ planLockedAt: string }>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/my-transfers/${transferId}/lock-plan`,
		{
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(`Lock plan request failed: ${response.status}`);
	}

	return response.json();
};
